<template>
  <div v-if="items !== null" :class="{ 'no-focus-effects': noFocusEffects }">
    <v-select
      v-model="model"
      :items="items"
      :label="label"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :dark="dark"
      :dense="dense"
      :flat="flat"
      :clearable="clearable"
      hide-selected
      :hint="hint"
      persistent-hint
      :error-messages="errorMessages"
      @input="onSelectionChange"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-select>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: 'If65Select',
  props: {
    api: {
      type: Function,
      required: true
    },
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Seleziona'
    },
    hint: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    extraParams: {
      type: Object,
      default: () => ({})
    },
    extraItems: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    noFocusEffects: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      model: null,
      loading: false
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.model = newVal;
      },
      immediate: true
    }
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.loading = true;
      const params = Object.assign({}, this.extraParams, { choices: '' });

      this.api(params)
        .then(response => {
          const items = _.cloneDeep(response.data);

          if (this.extraItems && this.extraItems.length) {
            for (const extraItem of this.extraItems) {
              items.push(extraItem);
            }
          }

          this.items = items;
          this.$emit('items-loaded', items);
        })
        .catch(error => {
          console.error("Error loading items:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSelectionChange(selected) {
      // Se selected è un oggetto, emetti solo il valore
      if (selected && typeof selected === 'object' && selected.value !== undefined) {
        this.$emit('input', selected.value);
        console.log('Emitting value:', selected.value);
      } else {
        // Altrimenti emetti il valore così com'è (potrebbe essere null)
        this.$emit('input', selected);
        console.log('Emitting raw value:', selected);
      }
    }
  }
};
</script>

<style scoped>
.v-select__selections {
  max-width: 100%;
  overflow: visible;
  white-space: nowrap;
}

/* Rimuove gli effetti di focus quando noFocusEffects è true */
.no-focus-effects >>> .v-input--is-focused .v-input__slot {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
  outline: none !important;
}

.no-focus-effects >>> .v-select--is-focused .v-input__slot {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
